import { render, staticRenderFns } from "./ImportacaoDialogErros.vue?vue&type=template&id=61960c66&lang=html&"
import script from "./ImportacaoDialogErros.vue?vue&type=script&lang=js&"
export * from "./ImportacaoDialogErros.vue?vue&type=script&lang=js&"
import style0 from "./ImportacaoDialogErros.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
